import React from "react";

import PropTypes from "prop-types";

import RbField from "../RbField";
import RbSelectControl from "../RbSelectControl";

function RbSelectField(props) {
  const { fieldName, required, ...other } = props;

  const validate = React.useCallback(
    (value) => {
      if (!value && required) {
        return "Required field";
      }

      return undefined;
    },
    [required]
  );

  return (
    <RbField
      fieldName={fieldName}
      Component={RbSelectControl}
      defaultEmptyValue=""
      validate={validate}
      required={required}
      {...other}
    />
  );
}

RbSelectField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

RbSelectField.defaultProps = {
  required: undefined,
};

export default React.memo(RbSelectField);
